import { GetStaticProps } from "next"
import contentful from "src/util/contentful"
import ContentfulDocument from "src/common/ContentfulDocument"

function Privacy({ document }) {
  return (
    <ContentfulDocument
      document={document}
      title='Privacy'
    />
  )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const entry = await contentful.getEntry<any>('6UY6jQ3mYfZ0cB6IcEnhM7')

  return {
    props: {
      document: entry.fields.body || {},
    },
  }
}

export default Privacy
